export const quickSearchFilter = {
  DESTINATION: 'quickSearchFilter.destination',
  DEPARTURE_DATE: 'quickSearchFilter.departureDate',
  AIRPORTS: 'quickSearchFilter.airports',
  ARRIVAL_AIRPORTS: 'searchFilter.arrivalAirports',
  DURATION: 'quickSearchFilter.duration',
  PARTICIPANTS: 'quickSearchFilter.participants',
  TRANSPORT: 'quickSearchFilter.transportType'
}
